// Source: apps.shopify.com/assisty, checked 2026-07-09 (same provenance as
// assisty-website). Update all three together when the listing changes.
export const PROOF_STATS = { rating: '4.8', reviews: '345', stores: '3,000+' };
